import { Outlet } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { useGetCases } from '@/hooks/api/use-get-cases';
import { ROUTES } from '@/router/routes';

import { FetchStates } from '../fetch-states';
import { Button } from '../ui/button';
import { CasesTable } from './cases-table';
import { Section } from '../content-layout/section';
import { SectionHeader } from '../content-layout/section-header';

export function CasesPage() {
  const { t } = useTranslation();
  const { cases, loading, error } = useGetCases();

  return (
    <>
      <Section>
        <SectionHeader title={t('cases-title')} element="h1">
          <Button href={ROUTES.NEW_CASE}>{t('case-create-title')}</Button>
        </SectionHeader>
        <FetchStates loading={loading} error={error?.message} reloadOnError>
          <div className="page-content">
            <CasesTable cases={cases ?? []} enableEditAction />
          </div>
        </FetchStates>
      </Section>
      <Outlet />
    </>
  );
}
